import { FC } from 'react'
import { Modal, Form, Input, InputNumber } from 'antd'
const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 14 },
}

interface ModalDataProps {
  type?: 'ADD' | "EDITOR"
  onAdd:(data) => void
  onEditor:(data) => void
  onCancel:() => void
}

const ModalData: FC<ModalDataProps> = ({ type, onAdd, onCancel, onEditor }) => {
  const [form] = Form.useForm()
  const onOk = () => {
    form.validateFields().then(res => {
      if (type === 'ADD') {
        onAdd(res)
      } else if (type === 'EDITOR') {
        onEditor(res)
      }
    })
  }
  return (
    <Modal
      destroyOnClose
      visible={!!type}
      centered
      title={type === 'ADD' ? '新增' : '修改'}
      onOk={onOk}
      onCancel={onCancel}
    >
      <Form {...layout} form={form} preserve={false}>
        {type === 'ADD' && (
          <Form.Item
            name="productId"
            label="Product ID"
            rules={[{ required: true, message: 'Please input Product ID' }]}
          >
            <Input />
          </Form.Item>
        )}
        <Form.Item
          label="Targeted Price"
          name="targetPriceFen"
          rules={[{ required: true, message: 'Please input Targeted Price' }]}
        >
          <InputNumber style={{ width: '100%' }} min={0} step={1} precision={0} />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default ModalData